import { render, staticRenderFns } from "./month.vue?vue&type=template&id=2f87d33f&lang=html"
import script from "./month.vue?vue&type=script&lang=js"
export * from "./month.vue?vue&type=script&lang=js"
import style0 from "./month.vue?vue&type=style&index=0&id=2f87d33f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports